/* eslint-disable prettier/prettier */

import { createSlice } from '@reduxjs/toolkit'

const invoicingReducer = createSlice({
    name: 'invoicingReducer',
    initialState: {
        unpaid: {},
        paid: {},
        
        currentPage:'',
        loading: false,
        invoicingCounts: {
            unpaid: 0,
            paid: 0,
        },
        searchText:{
            name: '',
            startDate: '',
            endDate: '',
            resNo:'',
            invoiceNo: ''
        },
        searchModal: true,
    },
    reducers: {
        setField(state, action) {
            state[action.payload.name] = action.payload.value
        },
        setUnpaid(state, action) {
            state.unpaid = action.payload
        },
        setPaid(state, action) {
            state.paid = action.payload
        },
        setSearchText(state, action) {
            state.searchText[action.payload.name] = action.payload.value
        },
      
        setInvoicingCounts(state, action) {
            state.invoicingCounts = action.payload
        },
        clearSearchForm(state, action) {
            state.searchText = {
                name: '',
                startDate: '',
                endDate: '',
                resNo:'',
                invoiceNo: ''
            }

        }

    },
});

export const {
    setUnpaid,
    setField,
    setSearchText,
    setPaid,
    clearSearchForm,
    setInvoicingCounts
} = invoicingReducer.actions;
export default invoicingReducer.reducer;